import { toTypedSchema } from '@vee-validate/zod'
import { object } from 'zod'
import { emailValidationSchema } from './index'

const resetPasswordSchema = toTypedSchema(
  object({
    email: emailValidationSchema,
  }),
)

export default resetPasswordSchema
